import {LazyLoadController} from 'extensions/ui-controllers';
import {PartialRenderController} from 'extensions/ui-controllers/partial-render';
import {defineCustomElement} from 'extensions/utils';
import {LitElement} from 'lit';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import stylesheet from './x-page-builder.component.scss?as=stylesheet';

/**
 * Load a page's Page Builder sequence item
 */
export class PageBuilderComponent extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			_content: {
				state: true,
				type: String
			},
			_loading: {
				state: true,
				type: Boolean
			},
			code: {
				type: String
			}
		};
	}

	constructor () {
		super();

		/**
		 * @type {string}
		 */
		this._content = '';

		/**
		 * @type {boolean}
		 */
		this._loading = true;

		/**
		 * @type {string}
		 */
		this.code = '';

		this.importedScripts = false;

		// Add controllers
		this.lazyLoadController = new LazyLoadController(this, this.onLazy.bind(this));
		this.partialRenderController = new PartialRenderController(this);
	}

	createRenderRoot () {
		return this;
	}

	async onLazy () {
		const url = new URL(window.mivaJS.Merchant_Url);
		url.searchParams.set('Screen', this.code);

		this._content = await this.partialRenderController.send(url.toString(), [
			'hdft:099fb995346f31c749f6e40db0f395e3',
			'sequence'
		]);

		this._loading = false;
	}

	render () {
		if (this._loading) {
			return unsafeHTML(this.innerHTML);
		}

		return unsafeHTML(this._content);
	}

	async updated () {
		if (this.importedScripts || this._loading) {
			return;
		}

		if (!this._content) {
			return;
		}

		this.importedScripts = true;
		const {default: globalLandingComponents} = await import('extensions/global-landing-components');
		globalLandingComponents();

		this.classList.add('loaded');
	}
};

defineCustomElement('x-page-builder', PageBuilderComponent);
